// import apolloClient from '../apolloClient'
// import globals from '../globals'
import { ApolloClient } from 'apollo-client'
import { ApolloLink, split } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { getMainDefinition } from 'apollo-utilities'
import ActionCable from 'actioncable'
import { ActionCableLink } from 'graphql-ruby-client'
import Logger from '@/lib/Logger'

/* global API_BASE_URL */

class GqlClient {
  // //
  static buildApolloClient(authString) {
    Logger.debug('GqlClient.buildApolloClient()', authString, authString && true)

    const httpLink = new HttpLink({
      uri: `${API_BASE_URL()}/graphql`,
    })

    if (!authString) {
      GqlClient.apolloClient = new ApolloClient({
        link: httpLink,
        //   connectToDevTools: true,
        cache: new InMemoryCache(),
      })
      Logger.debug('Creato apolloClient NON AUTENTICATO')
      GqlClient.is_authenticated = false
      return
    }
    try {
      const username = JSON.parse(authString).user
      const { token } = JSON.parse(authString)

      const auth_string = btoa(`${username}:${token}`)
      Logger.debug('connecting cable... ', auth_string)
      /* eslint no-undef: "error" */
      const cable = ActionCable.createConsumer(`${API_BASE_URL()}/cable?authstring=${auth_string}`)
      /* eslint no-undef: "error" */
      Logger.debug('CONNECTED CABLE:', cable)

      const authMiddleware = new ApolloLink((operation, forward) => {
        operation.setContext({
          headers: {
            authentication: auth_string,
          },
        })
        return forward(operation)
      })

      const splitLink = split(
        // split based on operation type
        ({ query }) => {
          const definition = getMainDefinition(query)
          return (
            definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
          )
        },
        new ActionCableLink({ cable }),
        authMiddleware.concat(httpLink),
      )

      GqlClient.apolloClient = new ApolloClient({
        link: splitLink,
        //   connectToDevTools: true,
        cache: new InMemoryCache(),
      })
    } catch (e) {
      Logger.debug('CCCC')
      Logger.error(e)
    }
    GqlClient.is_authenticated = true
  }

  // static bindQuery(gqlObj, updateCB) {
  //   /// DEPRECATED
  //   const observable = GqlClient.apolloClient.watchQuery(gqlObj)
  //   const sub = observable.subscribe(updateCB)

  //   const queryBind = {
  //     unbind() {
  //       sub.unsubscribe()
  //     },
  //     refetch() {
  //       observable.refetch()
  //     },
  //   }
  //   return queryBind
  // }

  static cachedQuery(gqlObj, cacheChangeCB, errorCB) {
    Logger.debug('cachedQuery', gqlObj)
    const self = this
    const observable = GqlClient.apolloClient.watchQuery(gqlObj)
    const sub = observable.subscribe(
      r => {
        Logger.debug('cachedQuery result', r)
        cacheChangeCB(r ? r.data[gqlObj.dataKey] : null)
      },
      e => {
        if (e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].message) {
          const originalMessage = e.graphQLErrors[0].message
          if (['TOKEN_MISSING', 'INVALID_TOKEN'].includes(originalMessage)) {
            self.resetAuthentication()
            errorCB({
              name: 'NOT_LOGGED',
              message: e.message,
            })
          } else if (originalMessage.match(/^[A-Z_0-9]+$/)) {
            // throw
            errorCB({
              name: originalMessage,
              message: e.message,
            })
          } else {
            throw e
          }
        }
        // Logger.debug('GqlClient.cachedQuery:', error.message)
        return true
      },
    )
    return {
      unbind() {
        sub.unsubscribe()
      },
      refetch() {
        return observable.refetch().catch(e => {
          Logger.error('Refetch failed')
          if (e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].message) {
            const originalMessage = e.graphQLErrors[0].message
            if (['TOKEN_MISSING', 'INVALID_TOKEN'].includes(originalMessage)) {
              self.resetAuthentication()
            } else if (originalMessage.match(/^[A-Z_0-9]+$/)) {
              // throw
              errorCB({
                name: originalMessage,
                message: e.message,
              })
            }
          }
        })
      },
    }
  }

  static subscribeQuery(gqlObj, updateCB) {
    try {
      const observable = GqlClient.apolloClient.subscribe(gqlObj)
      const sub = observable.subscribe(
        r => {
          Logger.debug('subscribeQuery event', r)
          updateCB(r ? r.data[gqlObj.dataKey] : null)
        },
        error => {
          Logger.debug('GqlClient.subscribeQuery:', error.message)
          return false
        },
      )
      const queryBind = {
        unbind() {
          sub.unsubscribe()
        },
      }
      return queryBind
    } catch (e) {
      Logger.debug('CCCC')
      Logger.error(e)
    }
  }

  static async runMutation(gqlObj) {
    Logger.debug('RUNMUTATION gqlObj', gqlObj)
    let result
    try {
      result = await GqlClient.apolloClient.mutate(gqlObj)
    } catch (e) {
      // Logger.debug('Ciao ', e)
      if (e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].message) {
        const originalMessage = e.graphQLErrors[0].message
        // Logger.debug("originalMessage", originalMessage)
        if (originalMessage.match(/^[A-Z_0-9]+$/)) {
          // Logger.debug('Errore in runMutation - rilanciato', e)
          throw {
            name: originalMessage,
            message: e.message,
          }
        } else {
          // Logger.debug('Errore in runMutation - non gesttito', e)
          throw e
        }
      } else {
        // Logger.debug('Errore in runMutation - non gesttito 2', e)
        throw e
      }
    }
    Logger.debug('MUTATION DONE', gqlObj)
    if ('dataKey' in gqlObj) return result.data[gqlObj.dataKey]
    else return result
  }

  // //* il limite qui è che in caso di notifica fa solo refetch, per fare cose più sofisticate bisogna
  // //* reimplementare questo giro ad hoc
  // static activeQuery({ retrieveGql, listenGql, onDataChange, onError }) {
  //   Logger.debug(listenGql, retrieveGql)
  //   const cachedQuery = this.cachedQuery(retrieveGql, onDataChange, onError)
  //   let remoteChangeSub = { unbind: () => {} }
  //   if (GqlClient.is_authenticated) {
  //     remoteChangeSub = this.subscribeQuery(listenGql, () => cachedQuery.refetch())
  //   }
  //   cachedQuery.refetch() // al momento del bind devo assicurarmi di avere i dati aggiornati
  //   return {
  //     refetch() {
  //       cachedQuery.refetch()
  //     },
  //     destroy() {
  //       cachedQuery.unbind()
  //       remoteChangeSub.unbind()
  //     },
  //   }
  // }

  //* il limite qui è che in caso di notifica fa solo refetch, per fare cose più sofisticate bisogna
  //* reimplementare questo giro ad hoc
  static activeQuery({ retrieveGql, listenGql, onDataChange, onError }) {
    Logger.debug(listenGql, retrieveGql)
    const cachedQuery = this.cachedQuery(retrieveGql, () => {}, onError)

    let remoteChangeSub = { unbind: () => {} }
    if (GqlClient.is_authenticated) {
      remoteChangeSub = this.subscribeQuery(listenGql, () => {
        cachedQuery._notify_counter = (cachedQuery._notify_counter || 0) + 1
        if (cachedQuery._ongoingRefetch) {
          Logger.special('R!', 'Notifica durante il refetch, la registro per dopo')
          cachedQuery._freshRefetchNeeded = true
        } else {
          Logger.special('R!', 'Notifica in condizioni pulite, faccio refetch')
          GqlClient.smartRefetch(cachedQuery, retrieveGql, onDataChange)
        }
      })
    }

    GqlClient.smartRefetch(cachedQuery, retrieveGql, onDataChange) // al momento del bind devo assicurarmi di avere i dati aggiornati

    return {
      refetch() {
        GqlClient.smartRefetch(cachedQuery, retrieveGql, onDataChange)
      },
      destroy() {
        cachedQuery.unbind()
        remoteChangeSub.unbind()
      },
    }
  }

  static smartRefetch(cachedQuery, retrieveGql, onDataChange) {
    cachedQuery._ongoingRefetch = (cachedQuery._ongoingRefetch || 0) + 1
    cachedQuery.refetch().then(data => {
      Logger.special('R!', 'Dati arrivati:', data)
      GqlClient.smartReceive(cachedQuery, retrieveGql, onDataChange, data)
    })
  }

  static smartReceive(cachedQuery, retrieveGql, onDataChange, result) {
    cachedQuery._ongoingRefetch--
    if (cachedQuery?._freshRefetchNeeded) {
      cachedQuery._freshRefetchNeeded = false
      Logger.special('R!', 'Sono arrivati i dati superati, li ignoro e rifaccio refetch')
      GqlClient.smartRefetch(cachedQuery, retrieveGql, onDataChange)
    } else {
      Logger.special('R!', 'Nessuna notifica pendente, aggiorno i dati')
      cachedQuery._notify_counter = 0 //sono le notifiche insoddisfatte
      onDataChange('dataKey' in retrieveGql ? result.data[retrieveGql.dataKey] : result.data)
    }
  }

  static initAuthentication(authObject) {
    const authString = JSON.stringify(authObject)
    localStorage.setItem('sharylist_authentication', authString)
    this.setAuthString(authString)
  }

  static resetAuthentication() {
    Logger.debug('GqlClient.resetAuthentication()')
    localStorage.removeItem('sharylist_authentication')
    this.setAuthString(null)
  }

  static reloadAuthString() {
    this.setAuthString(localStorage.sharylist_authentication)
  }

  static isLogged() {
    if (localStorage.getItem('sharylist_authentication')) {
      return true
    }
    return false
  }

  static setAuthString(authString) {
    // if (authString == 'null') {
    //   localStorage.removeItem('sharylist_authentication')
    //   return
    // }
    Logger.debug('GqlClient.setAuthString()')
    GqlClient.buildApolloClient(authString)
  }
}

export default GqlClient
